// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p_ae","label":"styles_label__2u15w"};